"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.custom-branding.disabled': 'La funzione branding personalizzato non è disponibile nel tuo piano attuale.',
};
